<app-breadcrumb></app-breadcrumb>
<mat-card class="cardWithShadow">
    <app-loader></app-loader>
    <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                    <mat-icon>
                        <i-tabler name="building-store" class="icon-20 m-r-8"></i-tabler>
                    </mat-icon>
                </div>
                {{ 'HOSPITALDETAILS' | translate }}
            </ng-template>
            <mat-card-content>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="hospital-form-container">
                            <form [formGroup]="hospitalDetailsForm">
                                <mat-card-content>

                                    <div class="row">
                                        <div class="col-sm-9">
                                            <mat-card class="cardWithShadow">
                                                <mat-card-content>
                                                    <mat-card-title>{{ 'LABEL.HOSPITALDETAILS_DESCRIPTION' | translate
                                                        }}</mat-card-title>
                                                    <mat-card-subtitle class="mat-body-1"></mat-card-subtitle>

                                                    <div class="row m-t-24">
                                                        <div class="col-sm-6">
                                                            <!-- input -->

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>Hospital Name</mat-label>
                                                                <input matInput placeholder="Hospital Name"
                                                                    formControlName="name" maxlength="50" required>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('name')?.hasError('required')">
                                                                    {{ 'REQUIRED.NAME' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('name')?.hasError('maxLength')">
                                                                    {{ 'REQUIRED.MAXIMUM50' | translate }}
                                                                </mat-error>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.PAN_LABEL' | translate
                                                                    }}</mat-label>
                                                                <input matInput [type]="hidePan ? 'password' : 'text'"
                                                                    placeholder="{{ 'LABEL.PAN_LABEL' | translate }}"
                                                                    formControlName="panNumber" maxlength="10"
                                                                    minlength="10">
                                                                <button mat-icon-button matSuffix type="button"
                                                                    (click)="hidePan = !hidePan">
                                                                    <mat-icon class="icon-eye">{{ hidePan ? 'visibility'
                                                                        :
                                                                        'visibility_off'
                                                                        }}</mat-icon>
                                                                </button>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('panNumber')?.hasError('required')">
                                                                    {{ 'REQUIRED.NAME' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('panNumber')?.hasError('invalidPan')">
                                                                    {{ 'VALIDATION.PAN_NUMBER' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('panNumber')?.hasError('maxLength')">
                                                                    {{ 'REQUIRED.MAXIMUM10' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('panNumber')?.hasError('minLength')">
                                                                    {{ 'REQUIRED.MINIMUM10' | translate }}
                                                                </mat-error>

                                                            </mat-form-field>
                                                            <!-- input -->

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.REGISTRATION_NUMBER' | translate
                                                                    }}</mat-label>
                                                                <input matInput
                                                                    placeholder="{{ 'LABEL.REGISTRATION_NUMBER' | translate }}"
                                                                    formControlName="registrationNumber">
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('registrationNumber')?.hasError('required')">
                                                                    {{ 'REQUIRED.NAME' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('registrationNumber')?.hasError('maxlength')">
                                                                    {{ 'REQUIRED.MAXIMUM20' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('registrationNumber')?.hasError('invalidAlphaNumeric')">
                                                                    {{ 'REQUIRED.REGISTRATION' | translate }}
                                                                </mat-error>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.PHONE_LABEL' | translate
                                                                    }}</mat-label>
                                                                <input matInput formControlName="phone"
                                                                    placeholder="Phone" maxlength="10"
                                                                    appAllowOnlyDigits />

                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('phone')?.hasError('required')">
                                                                    {{ 'REQUIRED.NAME' | translate }}
                                                                </mat-error>

                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('phone')?.hasError('minlength') || hospitalDetailsForm.get('phone')?.hasError('maxlength')">
                                                                    {{ 'REQUIRED.MINIMUM10' | translate }}
                                                                </mat-error>
                                                            </mat-form-field>


                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.MOBILE_LABEL' | translate
                                                                    }}</mat-label>
                                                                <input matInput
                                                                    placeholder="{{ 'LABEL.MOBILE_LABEL' | translate }}"
                                                                    formControlName="mobile" maxlength="10"
                                                                    appAllowOnlyDigits />

                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('mobile')?.hasError('required')">
                                                                    {{ 'REQUIRED.NAME' | translate }}
                                                                </mat-error>

                                                                <mat-error *ngIf="hospitalDetailsForm.get('mobile')?.hasError('minlength') || 
                                                        hospitalDetailsForm.get('mobile')?.hasError('maxlength')">
                                                                    {{ 'REQUIRED.MINIMUM10' | translate }}
                                                                </mat-error>

                                                            </mat-form-field>

                                                        </div>
                                                        <div class="col-sm-6">
                                                            <!-- input -->
                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.COUNTRY' | translate }}</mat-label>
                                                                <mat-select formControlName="country"
                                                                    (selectionChange)="onCountryChange($event.value)">
                                                                    <mat-option *ngFor="let country of Countries"
                                                                        [value]="country.name">
                                                                        {{country.name}}
                                                                        <!-- ({{country.isoCode}}) -->
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.STATE' | translate }}</mat-label>
                                                                <mat-select formControlName="state"
                                                                    (selectionChange)="onStateChange($event.value)">
                                                                    <mat-option *ngFor="let state of states"
                                                                        [value]="state.name">
                                                                        {{state.name}}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.CITY' | translate }} </mat-label>
                                                                <mat-select formControlName="city">
                                                                    <mat-option *ngFor="let city of cities"
                                                                        [value]="city.name">
                                                                        {{city.name}}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                                <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate
                                                                    }}</mat-label>
                                                                <textarea matInput
                                                                    placeholder="{{ 'LABEL.ADDRESS_LABEL' | translate }}"
                                                                    cols="5" rows="5"
                                                                    formControlName="address"></textarea>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('address')?.hasError('required')">
                                                                    {{ 'REQUIRED.NAME' | translate }}
                                                                </mat-error>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" class="w-100">
                                                                <mat-label>{{ 'LABEL.POSTALCODE_LABEL' | translate }}
                                                                </mat-label>
                                                                <input type="text" matInput
                                                                    placeholder="{{ 'LABEL.POSTALCODE_LABEL' | translate }}"
                                                                    formControlName="postalCode" maxlength="6"
                                                                    minlength="6">
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('postalCode')?.hasError('invalidNumber') && hospitalDetailsForm.get('postalCode')?.touched">
                                                                    {{ 'REQUIRED.POSTALCODE' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('postalCode')?.hasError('maxLength') && hospitalDetailsForm.get('postalCode')?.touched">
                                                                    {{ 'REQUIRED.MAXIMUM6' | translate }}
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="hospitalDetailsForm.get('postalCode')?.hasError('minLength') && hospitalDetailsForm.get('postalCode')?.touched">
                                                                    {{ 'REQUIRED.MINIMUM6' | translate }}
                                                                </mat-error>

                                                            </mat-form-field>

                                                        </div>
                                                        <div class="col-6 m-t-24">
                                                        </div>
                                                    </div>
                                                </mat-card-content>

                                            </mat-card>
                                        </div>
                                        <div class="col-sm-3">
                                            <mat-card class="cardWithShadow m-t-24">
                                                <mat-card-content class="p-y-24">
                                                    <mat-card-title>{{ 'ENTITY.CHANGE_PROFILE' | translate
                                                        }}</mat-card-title>
                                                    <mat-card-subtitle class="mat-body-1">{{ 'ENTITY.CHANGE_DESCRIPTION'
                                                        | translate
                                                        }}</mat-card-subtitle>
                                                    <div class="m-t-24">


                                                        <div class="flex flex-col items-center relative"
                                                            id="avatar-container"
                                                            (mouseenter)="showAddPhotoOverlay=true">
                                                            @if(imageUrl){
                                                            <img class="avatar-photo" #avatarImg [src]="imageUrl"
                                                                id="avatar-photo" alt="User avatar">

                                                            }@else {
                                                            <img *ngIf="hospitaldetailsfill" class="avatar-photo"
                                                                #avatarImg
                                                                [src]="hospitaldetailsfill.logo ? staticimagepath+ hospitaldetailsfill.logo : defaultAvatarPath"
                                                                id="avatar-photo" alt="User avatar"
                                                                fallbackImage="assets/images/profile/user-1.jpg">
                                                            }
                                                            <div *ngIf="showAddPhotoOverlay" id="add-photo-overlay"
                                                                class="avatar-photo" style="text-align: center;">
                                                                <button id="add-avatar-photo-button"
                                                                    class="center-positon-absolute" mat-icon-button
                                                                    (click)="fileInput.click();showAddPhotoOverlay=false">
                                                                    <mat-icon>add_a_photo</mat-icon>
                                                                </button>

                                                                <!-- Hover Menu -->
                                                                <mat-icon id="remove-avatar-photo-button"
                                                                    *ngIf="imageUrl && imageUrl !== ''"
                                                                    (click)="removePhoto();showAddPhotoOverlay=false"
                                                                    matTooltip="remove this photo">close</mat-icon>
                                                            </div>

                                                            <!-- Input file -->
                                                            <input #fileInput type="file"
                                                                (change)="onFileChanged($event)" name="avatar"
                                                                accept="image/png, image/jpeg" style="display:none;">
                                                        </div>
                                                        <span class="f-s-14 m-t-24 d-block">{{ 'VALIDATION.PHOTO_VALID'
                                                            | translate
                                                            }}</span>
                                                    </div>

                                                </mat-card-content>
                                            </mat-card>

                                        </div>
                                    </div>
                                    <div class="text-right p-t-0" *ngIf="isAdmin">
                                        <button mat-flat-button color="primary" class="m-r-8"
                                            (click)="onUpdateHospital()" [disabled]="hospitalDetailsForm.invalid">
                                            {{ 'BUTTON.BTN_SAVE' | translate }}
                                        </button>
                                    </div>
                                </mat-card-content>
                            </form>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                    <mat-icon>
                        <i-tabler name="printer" class="icon-20 m-r-8"></i-tabler>
                    </mat-icon>
                </div>
                {{ 'LABEL.PRINT_SETTINGS' | translate }}
            </ng-template>
            <mat-card-content class="p-0 b-t-1">
                <app-print-setting [hospitalInfo]="hospitaldetailsfill" [logoUrl]="logoUrl"></app-print-setting>
            </mat-card-content>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                    <mat-icon>
                        <i-tabler name="receipt" class="icon-20 m-r-8"></i-tabler>
                    </mat-icon>
                </div>
                {{ 'ENTITY.BILL_CHARGE' | translate }}
            </ng-template>
            <mat-card-content class="b-t-1">
                <app-bill-charge></app-bill-charge>
            </mat-card-content>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                    <mat-icon>
                        <i-tabler name="stethoscope" class="icon-20 m-r-8"></i-tabler>
                    </mat-icon>
                </div>
                {{ 'ENTITY.SPECIALITY' | translate }}
            </ng-template>
            <mat-card-content class="p-y-24 b-t-1">
                <app-doctor-speciality></app-doctor-speciality>
            </mat-card-content>
        </mat-tab>

    </mat-tab-group>
</mat-card>